module.exports = __webpack_public_path__ + "static/media/gettyimages-1266986195-612x612.15f3d1be.jpg";